import RoomTypeChipContent from './RoomTypeChipContent';

import type { OfferFilter } from '@shared/types/frontend/ubff/hotel-detail-price';
import type { I18nService } from '@shared/types/i18n';

import STYLES from './RoomTypeFilters.module.scss';

import { useRoomTypeFilterWithPrice } from '@hotels-hotel-detail/data-access/hooks/useHotelOffersContext';
import BpkMultiSelectChipGroup, {
  CHIP_GROUP_TYPES,
  type ChipItem,
} from '@shared/ui/common/BpkChipGroup';
import { withI18n } from '@shared/ui/contexts/i18n';

type Props = {
  i18n: I18nService;
};

const getRoomTypeChip = (
  filters: OfferFilter,
  filterOptionOnClick: Function,
) => {
  const chipItems: ChipItem[] = [];
  filters.options.forEach((filter) =>
    chipItems.push({
      text: filter.displayName,
      // @ts-expect-error TODO: ensure click handler is correctly typed in the next TK - BD-10138
      onClick: filterOptionOnClick,
      selected: filter.selected,
      content: (
        <RoomTypeChipContent
          displayName={filter.displayName}
          price={!Number.isNaN(Number(filter.label)) ? Number(filter.label) : 0}
        />
      ),
      className: STYLES.RoomTypeFilters__chip,
    }),
  );

  return chipItems;
};

const RoomTypeFilters = ({ i18n: { translate } }: Props) => {
  const filters = useRoomTypeFilterWithPrice();

  if (!filters?.options?.length) return null;

  return (
    <div className={STYLES.RoomTypeFilters}>
      <BpkMultiSelectChipGroup
        ariaLabel={translate('Filters_label_filterBy')}
        type={CHIP_GROUP_TYPES.rail}
        chips={getRoomTypeChip(filters, () => {})}
        leadingNudgerLabel={translate(
          'Offer_filters_chip_group_leading_nudger_label',
        )}
        trailingNudgerLabel={translate(
          'Offer_filters_chip_group_trailing_nudger_label',
        )}
      />
    </div>
  );
};

export default withI18n(RoomTypeFilters);
